import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import EventsSection from '../components/EventsSection';
import EventIcon from '@mui/icons-material/Event';
import DecorativeCubes from '../components/DecorativeCubes';

const EventsPage = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <DecorativeCubes minCubes={8} maxCubes={12} />
      <Header />
      <Box sx={{ position: 'relative', zIndex: 2 }}>
        <EventsSection />
      </Box>
      <Footer />
    </Box>
  );
};

export default EventsPage;
